<!--涨停筛选-->
<template>
<div class="mod clearfix mod-filters">
    <h2><i>13</i>一键涨停筛选</h2>
    <div class="filter-main">
        <div class="fl filter-tab">
            <div :class="{cur:liveCur=='MACDJC'}"  @click="actvieTab('MACDJC')">
                <h5><b>MACD金叉</b><span class="fr">{{mnum}}只</span></h5>
                <p>选股类型：指标形态选股</p>
            </div>
            <div :class="{cur:liveCur=='DBHSB'}"  @click="actvieTab('DBHSB')">
                <h5><b>底部红三兵</b><span class="fr">{{dnum}}只</span></h5>
                <p>选股类型：K线形态选股</p>
            </div>
            <div :class="{cur:liveCur=='SDHT'}" @click="actvieTab('SDHT')">
                <h5><b>深跌回弹</b><span class="fr">{{snum}}只</span></h5>
                <p>选股类型：K线形态选股</p>
            </div>
            <div :class="{cur:liveCur=='JDXG'}" @click="actvieTab('JDXG')">
                <h5><b>阶段新高</b><span class="fr">{{jnum}}只</span></h5>
                <p>选股类型：K线形态选股</p>
            </div>
           
        </div>
        <div class="filter-content">
            <div class="filter-content-item">
                <div class="content-item-hd">
                    <h5><b>{{title}}</b><span class="fr">选股日期：{{date}}</span></h5>
                    <p>{{des}}</p>
                </div>
                <div class="content-item-table">
                    <table width="100%" cellpadding="0" cellspacing="0" class="table-hd">
                        <tr>
                            <th width="36"></th><th width="100">代码</th><th width="100">名称</th><th width="100">涨幅%</th><th width="100">涨跌</th><th width="100">涨速%</th><th width="100">现价</th><th>总手</th>
                        </tr>
                    </table>
                    <div v-if="contentshowm">
                    <table width="100%" cellpadding="0" cellspacing="0" class="table-bd"  v-html="contentm">
                    </table></div>
                    <div v-if="contentshowd" id="seattle">
                    <table width="100%" cellpadding="0" cellspacing="0" class="table-bd"  v-html="contentd">
                    </table></div>
                    <div  v-if="contentshows">
                    <table width="100%" cellpadding="0" cellspacing="0" class="table-bd" v-html="contents">
                    </table></div>
                    <div v-if="contentshowj">
                    <table width="100%" cellpadding="0" cellspacing="0" class="table-bd"  v-html="contentj">
                    </table></div>
                </div>
            </div> 
        </div>
    </div>
</div>
</template>
<script>
export default {
  data() {
    return {
      date: null,
      contentm: null,
      contentd: null,
      contents: null,
      contentj: null,

      contentshowm: null,
      contentshowd: null,
      contentshows: null,
      contentshowj: null,

      cur: null,
      liveCur: null,
      num: null,
      mnum: null,
      dnum: null,
      snum: null,
      jnum: null,
      title: null,
      des: null
    };
  },
  mounted: function() {
    this.actvieTab("MACDJC");
  },
  methods: {
    fmtStr(obj){
      var str = "'VIEWSTOCK?DATATYPE=DAY&LABEL="+obj+"&PAGE=分时走势;VIEWINDI?NUMPIC=3&INDI1=MA&INDI2=VOL;INDI3=SVNS'";
      return str;
    },
    clsStr(stockname){
      if(stockname.length > 7){
        return 'font-s';
      }else if (stockname.length >5 && stockname.length <= 7){
        return 'font-m';
      }else{
        return '';
      }
    },
    pushHangQing(str) {
      var self = this;

      //dzhyun.cancel();
      dzhyun.subscribe(
        "/stkdata",
        {
          obj: str,
          field:
            "ZhongWenJianCheng,ZuiXinJia,ZhangFu,ZhangDie,FenZhongZhangFu5,ChengJiaoLiang",
          mode: 2
        },
        data => {
          var html = "";
          data.forEach((item, index) => {
            html +=
              '<tr><td width="36">' +
              (parseInt(index) + 1) +
              '</td><td width="100">' +
              item.Obj.slice(2) +
              '</td><td width="100" class='+self.clsStr(item.ZhongWenJianCheng)+'><a href="javascript:void(0);" onclick="window.external.addcommand('+self.fmtStr(item.Obj)+')">' +
              item.ZhongWenJianCheng +
              "</a></td>";
            if(item.ZhangFu == null || item.ZhangFu==0){
              html += '<td width="100" class="red">' +  "-</td>";
            }else if (item.ZhangFu > 0) {
              html += '<td width="100" class="red">' + item.ZhangFu + "%</td>";
            } else {
              html +=
                '<td width="100" class="green">' + item.ZhangFu + "%</td>";
            }
            
            if(item.ZhangDie == null || item.ZhangDie==0){
              html += '<td width="100" class="red">'  +'-</td>';
            }else if(item.ZhangDie > 0){
              html += '<td width="100" class="red">' +item.ZhangDie +'</td>';
            }else{
              html += '<td width="100" class="green">' +item.ZhangDie +'</td>';
            }

            if ((item.FenZhongZhangFu5 == null || item.FenZhongZhangFu5==0)) {
              html+='<td width="100" class="red">-</td>';
            }else if(item.FenZhongZhangFu5>0){
              html+='<td width="100" class="red">'+item.FenZhongZhangFu5+'</td>';
            }else{
              html+='<td width="100" class="green">'+item.FenZhongZhangFu5+'</td>';
            }

            if ((item.ZuiXinJia == null || item.ZuiXinJia==0)) {
              html+='<td width="100">'  +"-</td><td>";
            }else{
              html+='<td width="100">' +item.ZuiXinJia +"</td><td>";
            }

            if ((item.ChengJiaoLiang == null || item.ChengJiaoLiang==0)) {
              html+="<td>"  +"-</td></tr>";
            }else{
              html+="<td>" +item.ChengJiaoLiang +"</td></tr>";
            }
             
          });
          if (this.liveCur == "MACDJC") {
            this.contentshowm = true;
            this.contentshowd = false;
            this.contentshows = false;
            this.contentshowj = false;
            this.contentm = html;
          } else if (this.liveCur == "DBHSB") {
            this.contentshowm = false;
            this.contentshowd = true;
            this.contentshows = false;
            this.contentshowj = false;
            this.contentd = html;
          } else if (this.liveCur == "SDHT") {
            this.contentshowm = false;
            this.contentshowd = false;
            this.contentshows = true;
            this.contentshowj = false;
            this.contents = html;
          } else if (this.liveCur == "JDXG") {
            this.contentshowm = false;
            this.contentshowd = false;
            this.contentshows = false;
            this.contentshowj = true;
            this.contentj = html;
          }
        }
      );
    },
    actvieTab(str) {
      if (str == "MACDJC") {
        this.liveCur = "MACDJC";
        this.contentshowm = true;
        this.contentshowd = false;
        this.contentshows = false;
        this.contentshowj = false;

        this.num = 0;
        this.title = "MACD金叉";
        this.des = "MACD由绿柱转红，可能是一个起涨信号";
      } else if (str == "DBHSB") {
        this.liveCur = "DBHSB";
        this.contentshowm = false;
        this.contentshowd = true;
        this.contentshows = false;
        this.contentshowj = false;
        this.num = 1;
        this.title = "底部红三兵";
        this.des =
          "近20天的低点附近，出现连续三根上涨阳线，是一个强烈的看涨信号";
      } else if (str == "SDHT") {
        this.liveCur = "SDHT";
        this.contentshowm = false;
        this.contentshowd = false;
        this.contentshows = true;
        this.contentshowj = false;
        this.num = 2;
        this.title = "深跌回弹";
        this.des = "近20天从最高点跌幅超过25%，目前正处于反弹的个股";
      } else if (str == "JDXG") {
        this.liveCur = "JDXG";
        this.contentshowm = false;
        this.contentshowd = false;
        this.contentshows = false;
        this.contentshowj = true;
        this.num = 3;
        this.title = "阶段新高";
        this.des =
          "当天收盘创出20天内的最高价，表明上涨趋势很强，后续可能继续创新高";
      }
      let self = this;
      dzhyun
        .query(
          "/stockpool",
          {
            pool: "复盘神器",
            cell: "MACDJC,DBHSB,SDHT,JDXG"
          },
          resStockList => {
            this.date = resStockList[0].CeWenShiJian.substring(0, 10);
          }
        )
        .then(function(data) {
          data[0].Pooldata.forEach(item => {
            if (item.Text == "MACDJC") {
              if (typeof item.Stk != "undefined") {
                self.mnum = item.Stk.length;
              } else {
                self.mnum = 0;
              }
            } else if (item.Text == "DBHSB") {
              if (typeof item.Stk != "undefined") {
                self.dnum = item.Stk.length;
              } else {
                self.dnum = 0;
              }
            } else if (item.Text == "SDHT") {
              if (typeof item.Stk != "undefined") {
                self.snum = item.Stk.length;
              } else {
                self.snum = 0;
              }
            } else if (item.Text == "JDXG") {
              if (typeof item.Stk != "undefined") {
                self.jnum = item.Stk.length;
              } else {
                self.jnum = 0;
              }
            }
          });
          var list = data[0].Pooldata[self.num];
          if (list.Text == self.liveCur) {
            var str = [];
            if (typeof list["Stk"] != "undefined") {
              list["Stk"].forEach(item => {
                str.push(item.Obj);
              });
              self.pushHangQing(str);
            }
          }
        });
    }
  }
};
</script>


// WEBPACK FOOTER //
// src/pages/home/components/ztsx.vue